import WelcomeBanner from './WelcomeBanner';
import DigitechRelumJackpot from '../casino/DigitechRelumJackpot';

export default function HomeHero({
  onNavigate,
  onRegister,
  onWelcomeLanding,
  onPromoDetails,
  afterBanner = null,
  showJackpot = true,
}) {
  return (
    <div className="home-hero">
      <div className="home-hero__banner">
        <WelcomeBanner
          onRegister={onRegister}
          onWelcomeLanding={onWelcomeLanding}
          onNavigate={onNavigate}
          onPromoDetails={onPromoDetails}
        />
      </div>
      {afterBanner}
      {showJackpot ? (
        <div className="home-hero__side home-hero__jackpot" data-reveal-item>
          <DigitechRelumJackpot onNavigate={onNavigate} hideHeader autoPlayMs={8000} />
        </div>
      ) : null}
    </div>
  );
}
